import { IconPlusOutline18 as PlusIcon } from "nucleo-ui-outline-18"

import { Button } from "@productlane/ui"

import { RoleCheck } from "@/components/shared/role-check"

interface Props {
	onClick: () => void
	variant?: "default" | "outline"
	size?: "default" | "sm"
}

export function ImportIssuesButton({
	onClick,
	variant = "default",
	size = "default",
}: Props) {
	return (
		<RoleCheck not={["VIEWER"]}>
			<Button variant={variant} size={size} Icon={PlusIcon} onClick={onClick}>
				Import issues
			</Button>
		</RoleCheck>
	)
}
